import {API, Setup} from '../../Services';

async function HistoryData(topic){
    let mallId= localStorage.getItem('mallId');
    let token =  localStorage.getItem('token');
    return API.get(`/messaging/messages`,{headers: { 'Authorization':  `Bearer ${token}`}, params:{topic:topic}});
}

async function NextData(url){
    let token =  localStorage.getItem('token');
    return API.get(`/messaging/messages?`+url,{headers: { 'Authorization':  `Bearer ${token}`}});
}

async function NotifyChat(reqObj){
    let mallId= localStorage.getItem('mallId');
    let token =  localStorage.getItem('token');
    return API.post(`/malls/${mallId?mallId:Setup.default_malls}/user_topics`,reqObj,{ headers: { 'Authorization':  `Bearer ${token}`} });
}

async function SendFile(form_data,topic) {
    let mallId = localStorage.getItem('mallId');
    let token = localStorage.getItem('token');
    return API.post(`/malls/${mallId ? mallId : Setup.default_malls}/user_topics/${topic}/files`, form_data,
        {
            headers: {
                'Authorization': `Bearer ${token}`,
                'content-type': 'multipart/form-data'
            }
        }
    );
}


export {HistoryData,NotifyChat,SendFile,NextData};